module.exports = __webpack_public_path__ + "static/media/speech.4b2a6cda.jpg";